import { render, staticRenderFns } from "./Caption.vue?vue&type=template&id=737381eb&scoped=true&"
var script = {}
import style0 from "./Caption.vue?vue&type=style&index=0&id=737381eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737381eb",
  null
  
)

export default component.exports